import { Component } from '@ribajs/core'
import type { SbProductBadges } from '../types'

interface Scope {
  badges: SbProductBadges | null
}

export class SbProductBadgesComponent extends Component {
  public static tagName = 'sb-product-badges'

  public scope: Scope = {
    badges: null,
  }

  static get observedAttributes(): string[] {
    return ['badges']
  }

  protected requiredAttributes(): string[] {
    return ['badges']
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbProductBadgesComponent.observedAttributes)
  }

  async afterBind() {
    this.classList.add(`${SbProductBadgesComponent.tagName}-ready`)
    await super.afterBind()
  }

  protected template() {
    return null
  }
}
